import React, { HTMLAttributes } from "react";
import { Link } from "react-router-dom";
import packageJson from "../../../../package.json";
import { ROUTE_PATHS } from "../../../routes/paths/route-paths";
import BaseButton from "../../atoms/baseButton";
import SocialMediaSection from "../socialMediaSection";
const APPVERSION = packageJson.version;

interface IFooter {
  showConactUsButton?: boolean;
}

type TFooterProps = IFooter & HTMLAttributes<HTMLDivElement>;

const Footer: React.FC<TFooterProps> = (props) => {
  const { showConactUsButton = true, ...otherProps } = props;

  return (
    <div className="flex flex-col laptop:flex-row bg-[#666666] gap-6 w-full justify-between items-center px-6 py-10 laptop:p-10 text-sm text-[#999999]">
      {showConactUsButton && (
        <Link
          to={ROUTE_PATHS.CONTACT_US_PAGE}
          className="w-full laptop:w-fit laptop:order-1"
        >
          <BaseButton className="w-full laptop:w-[16.75rem]">
            <div className="flex flex-col text-white">
              <span>聯絡我們</span>
              <span>Contact Us</span>
            </div>
          </BaseButton>
        </Link>
      )}
      <div className="flex flex-col gap-4">
        <div className="flex flex-row gap-5 items-center">
          <SocialMediaSection />
          <div className="flex flex-row gap-5">
            <a
              href="/privacy-policy-of-AGL.pdf"
              target="_blank"
              className="underline hover:text-white"
              referrerPolicy="no-referrer"
            >
              Privacy Policy
            </a>
            <a
              href="/TNC-of-AGL.pdf"
              target="_blank"
              className="underline hover:text-white"
              referrerPolicy="no-referrer"
            >
              Terms
            </a>
          </div>
        </div>
        <div className="flex text-xs laptop:flex-none">
          <span>
            Copyright© 2024 ASGARD All rights reserved. | Version:
            {APPVERSION}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
